// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-footer {
  z-index: 999;
}

.footer ion-toolbar {
  --color: var(--footer-text);
  box-shadow: var(--toolbar-shadow);
  --min-height: 36px;
}
.footer ion-toolbar ion-buttons ion-button.button-clear {
  --color: var(--main-top-text);
  --color-activated: var(--main-top-text);
  --border-radius: 0;
}
.footer ion-toolbar ion-buttons ion-button {
  width: 100%;
}
.footer ion-toolbar ion-buttons ion-button .btn-body {
  font-size: 12px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.footer ion-button.footer-button.button-has-icon-only {
  font-size: 17px;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
}
.footer ion-button ion-icon.small-icon {
  font-size: 20px;
}
.footer ion-badge {
  font-size: 11px;
  position: absolute;
  bottom: 0px;
  margin: auto;
  left: 0;
  right: 0;
  padding: 2px;
  width: -moz-fit-content;
  width: fit-content;
  --background: var(--button-a-background);
  --color: var(--button-a-text);
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/general/admin-footer/admin-footer.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AASE;EAEE,2BAAA;EAEA,iCAAA;EAmDA,kBAAA;AA1DJ;AAeI;EACE,6BAAA;EACA,uCAAA;EACA,kBAAA;AAbN;AAiBM;EACE,WAAA;AAfR;AAiBQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAfV;AA4CE;EAIE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AA7CJ;AAgDE;EACE,eAAA;AA9CJ;AAiDE;EACE,eAAA;EACA,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;EAEA,wCAAA;EACA,6BAAA;AAjDJ","sourcesContent":["ion-footer {\n  z-index: 999;\n}\n\n@media screen and (min-width: 1000px) {\n  ion-footer {\n    //display: none;\n  }\n}\n\n.footer {\n  ion-toolbar {\n    //--background: var(--footer-background);\n    --color: var(--footer-text);\n\n    box-shadow: var(--toolbar-shadow);\n\n    //border-top-right-radius: 15px;\n    //border-top-left-radius: 15px;\n\n    //width: 99%;\n    //margin: auto;\n\n    ion-buttons ion-button.button-clear {\n      --color: var(--main-top-text);\n      --color-activated: var(--main-top-text);\n      --border-radius: 0;\n    }\n\n    ion-buttons {\n      ion-button {\n        width: 100%;\n\n        .btn-body {\n          font-size: 12px;\n          width: 100%;\n          height: 100%;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n        }\n      }\n    }\n\n    //  //width: fit-content;\n    //  //  font-size: 13px;\n    //  width: 100%;\n    //  height: 100%;\n    //  --border-radius: 0;\n    //\n    //  .btn-body {\n    //    font-size: 15px;\n    //\n    //    ion-label {\n    //      font-size: 12px;\n    //    }\n    //\n    //    div {\n    //      width: 100%;\n    //      text-align: center;\n    //    }\n    //  }\n    //}\n\n\n    --min-height: 36px;\n  }\n\n  ion-button.footer-button.button-has-icon-only {\n    //margin-right: auto;\n    //margin-left: auto;\n\n    font-size: 17px;\n    --padding-start: 0;\n    --padding-end: 0;\n    --padding-top: 0;\n    --padding-bottom: 0;\n  }\n\n  ion-button ion-icon.small-icon {\n    font-size: 20px;\n  }\n\n  ion-badge {\n    font-size: 11px;\n    position: absolute;\n    //top: 33px;\n    bottom: 0px;\n    margin: auto;\n    left: 0;\n    right: 0;\n    padding: 2px;\n    width: fit-content;\n\n    --background: var(--button-a-background);\n    --color: var(--button-a-text);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
